export interface ProductAttribute {
  id: number;
  name: string; // eg. 烘焙度
  taxonomy: string; // eg: pa_color
  type: "select" | "text";
  order: "menu_order" | "name" | "id";
  has_archives: boolean;
  count: number; // 被多少個產品使用
}

export interface ProductAttributeTerm {
  id: number;
  name: string;
  slug: string;
  description: string;
  parent: number;
  count: number;
}

export enum RoastAttrTerms {
  LIGHT_ROAST = "light-roast",
  MEDIUM_ROAST = "medium-roast",
  MEDIUM_DARK_ROAST = "medium-dark-roast",
}
